import Vue from 'vue'
import BlankView from './BlankView.vue'
import SplitView from './SplitView.vue'

Vue.component('BlankView', BlankView)
export { BlankView, SplitView }
